
























































































































































































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import Order from './Order.vue';
import { GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import { DocumentShowType } from '../Shared/DocumentHeader.vue';
import { parseAccountingCost } from '@/app/Order';
import Bugsnag from '@bugsnag/js';
import { cloneDeep } from 'lodash';

@Component
export default class OrderLineExtension extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public line!: any;
  @Prop({ type: Boolean, default: false }) public expanded!: boolean;

  @Inject() public documentComponent!: Order;
  @Inject() public documentShowType!: DocumentShowType;

  private showCar = this.documentComponent.displaySettings.invoiceLineCar || this.hasCar();
  private showProject = this.documentComponent.displaySettings.invoiceLineProject || this.hasProject();
  private showDepartment = this.documentComponent.displaySettings.invoiceLineDepartment || this.hasDepartment();

  get editable() {
    return this.documentComponent.reactiveProps.editable;
  }

  public accountingCost() {
    return parseAccountingCost(this.line.accountingCost, this.line);
  }

  public hasCar() {
    return this.editable
      ? !!(this.line.car && this.line.car.id)
      : this.accountingCost().car.present;
  }

  public hasProject() {
    return this.editable
      ? !!(this.line.project && this.line.project.id)
      : this.accountingCost().project.present;
  }

  public hasDepartment() {
    return this.editable
      ? !!(this.line.department && this.line.department.id)
      : this.accountingCost().department.present;
  }

  public hasCpd() {
    return this.hasCar() || this.hasProject() || this.hasDepartment();
  }

  public get colspan() {
    let colspan = 7;
    if (this.documentShowType !== 'packingSlip') {
      if (this.documentComponent.displayLineAllowanceChargeColumn) colspan += 1;
      if (this.documentComponent.displaySettings.invoiceLineTaxAmount) colspan += 1;
    } else {
      colspan = 3;
    }

    if (this.documentComponent.displaySettings.invoiceLineOrderedQuantity) colspan += 1;
    return colspan;
  }

  public printCar(car: GQL_currentUnitCars_currentUnit_cars) {
    return `${car.registrationNumber} - ${car.name}`;
  }

  public printProject(project: GQL_currentUnitProjects_currentUnit_projects) {
    return `${project.code} - ${project.name}`;
  }

  public printDepartment(department: GQL_currentUnitDepartments_currentUnit_departments) {
    return `${department.code} - ${department.name}`;
  }

  public setCar(car: GQL_currentUnitCars_currentUnit_cars) {
    if (!car.id) return;
    this.line.car = car;
    Bugsnag.leaveBreadcrumb('Car set in order line extension', { line: cloneDeep(this.line), car});
  }

  public setProject(project: GQL_currentUnitProjects_currentUnit_projects) {
    if (!project.id) return;
    this.line.project = project;
    Bugsnag.leaveBreadcrumb('Project set in order line extension', { line: cloneDeep(this.line), project});
  }

  public setDepartment(department: GQL_currentUnitDepartments_currentUnit_departments) {
    if (!department.id) return;
    this.line.department = department;
    Bugsnag.leaveBreadcrumb('Department set in order line extension', { line: cloneDeep(this.line), department});
  }

  public unsetCar() {
    this.line.car = { id: null };
    Bugsnag.leaveBreadcrumb('Car unset in order line extension');
  }

  public unsetProject() {
    this.line.project = { id: null };
    Bugsnag.leaveBreadcrumb('Project unset in order line extension');
  }

  public unsetDepartment() {
    this.line.department = { id: null };
    Bugsnag.leaveBreadcrumb('Department unset in order line extension');
  }
}
